// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1TZNu","footer":"ReportModalFilter_footer__19LLc"};